import { render, staticRenderFns } from "./PartsIcon.vue?vue&type=template&id=5b058606&scoped=true"
import script from "./PartsIcon.vue?vue&type=script&lang=js"
export * from "./PartsIcon.vue?vue&type=script&lang=js"
import style0 from "./PartsIcon.vue?vue&type=style&index=0&id=5b058606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b058606",
  null
  
)

export default component.exports